<template>
    <div v-if="memberType == 'company'"  class="bussiness">
        <guid-tour v-if="isGuided === 'false' && isVerified === 'NORMAL'"></guid-tour>
        <no-right></no-right>
        <verified-status-alarm></verified-status-alarm>
        <div class="bussiness-nav">
            <biz-menu></biz-menu>
            <biz-menu-mb></biz-menu-mb>
        </div>
        <div class="bussiness-wrap">
            <biz-tool-bar></biz-tool-bar>
            <!-- <div class="home-banner" v-if="$route.name === 'bizHomeDefault'">
                <a href="https://flypig-public.s3-ap-southeast-1.amazonaws.com/advertisement/fly_pig_obis/index.html" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/obis/obis.png" alt="">
                </a>
            </div> -->
            <biz-breadcrumb />
            <loading-animation v-if="loadingState == 1"></loading-animation>
            <transition v-show="!loadingState" name="fade"> 
                <router-view ></router-view>
            </transition> 
        </div>
    </div>
</template>
<script>
import bizBreadcrumb from '@/components/bussiness/widges/tools/bizBreadcrumb.vue';
import verifiedStatusAlarm from '@/components/bussiness/widges/alarms/verifiedStatusAlarm.vue';
import guidTour from '@/components/bussiness/widges/tips/guidTour.vue'
import bizMenu from '@/components/bussiness/widges/menu/bizMenu.vue'
import bizMenuMb from '@/components/bussiness/widges/menu/bizMenuMb.vue'
import bizToolBar from '@/components/bussiness/widges/menu/bizToolBar.vue';
import noRight from '@/components/bussiness/widges/modals/noRight.vue';
import LoadingAnimation from '@/components/widge/LoadingAnimation.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            isGuided: null
        }
    },
    mounted() {
        // 取得會員權限
        this.$store.dispatch('bizGetUserInfo')
        this.$store.dispatch('getBizOrgGroupList')
        this.$store.dispatch('getBizLandlordList')
        this.$store.dispatch('getBizTodoCount')
        this.isGuided = localStorage.getItem('isGuided')
    },
    watch: {
        isVerified: {
            handler: function (val) {
                if(val === 'NORMAL' && this.isGuided === 'false'){
                    this.$router.push({name: 'bizHomeDefault'})
                }else if(val === 'NOT_AUDITS' || val === 'UNDER_REVIEW'){
                    this.$store.dispatch('bizLogout')
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請稍待營運人員審核',type: 'error',closeBtn: true})
                }
            },
            deep: true,
            // immediate: true
        },
        isAllGroup: {
            handler: function (val) {
                console.log(val)
                if(!val){
                    this.$store.dispatch('getBizMemberByGroupList', this.groupId)
                }
            },
            deep: true,
            immediate: true
        },
        $route:{
            handler: function (val) {
                this.$store.dispatch('getBizTodoCount')
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters({
            loadingState: 'GET_LOADING_STATE',
            memberType: 'GET_BIZ_USER_MEMBER_TYPE',
            isVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupId: 'GET_BIZ_USER_GROUP_ID'
        })
    },
    components: {
        bizMenu,
        bizToolBar,
        LoadingAnimation,
        bizBreadcrumb,
        verifiedStatusAlarm,
        bizMenuMb,
        guidTour,
        noRight
    }
}
</script>
<style lang="scss">
    .bussiness{
        position: relative;
        display: flex;
        min-width: 1280px;
        .bussiness-nav{
            position: relative;
            width: 22.27%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
        }
        .bussiness-wrap{
            position: relative;
            width: 77.73%;
            // margin-left: 186px;
            background: #f6f6f6;
            .home-banner{
                display: flex;
                align-items: center;
                justify-content: center;
                background: url('../../assets/img/obis/bg.svg');
                height: 60px;
                width: 1170px;
                margin-bottom: -15px;
            }
        }
    }
    @media screen and (max-width: 1440px) {
        .bussiness{
            .bussiness-nav{
                width: 15.27%;
            }
            .bussiness-wrap{
                width: 84.73%;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .bussiness{
            .bussiness-nav{
                width: 80px;
            }
            .bussiness-wrap{
                width: 1200px;
                
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/bussiness.vue